/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import moment from "moment";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import createcohortmodel from "./createcohortmodel.vue";



export default {
  name: "StudyArm",
  components: {
    VPagination,
    createcohortmodel,
  },
  data() {
    return {
      searchField: {
        country: "",
        status: "",
      },
      baseurl: process.env.VUE_APP_Service_URL,
      currentPage: 1,
      totalPage: 1,
      pageindex: 1,
      pagesize: 15,
      SortProperty: "createdAt",
      SortOrder: 1,
      SortOrderInt: 0,
      isAscending: true,
      CohortList: [],
      totalCount: 0,
      showTableLoading: false,

      idToken: "",
      showFilter: false,
      selectedcolumnobj: {},
      roleprivileges: "",
      dropdownOpen: false,
      showCreateCohortModal: false,
      editingCohortId: null,
    }
  },
  watch: {
    returnList: {
      handler() {
        this.initializeColumns();
      },
      immediate: true,
      deep: true,
    },
  },
  computed:{
    rollsprivilages() {
    return store.getters.getRolesprivilegeData || [];
  }
  },


  async mounted() {
    window.addEventListener("studyIdChanged", (event) => {
      console.log("StudyIDChanged into" + event.detail.storage);
      this.idToken = store.getters.getIdToken;
      this.listCohort();
    });
    await this.listCohort();
  },

  methods: {
    SortSelected(sortProp) {
  if (this.SortProperty === sortProp) {
    this.isAscending = !this.isAscending;
  } else {
    this.SortProperty = sortProp;
    this.isAscending = true;
  }

  this.SortOrderInt = this.isAscending ? 0 : 1;
  this.pageindex = 1;
  this.currentPage = 1;

  this.listCohort();
},
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
    initializeColumns() {
      if (this.CohortList.length > 0) {
        const allowedKeys = [
          "Country Name",
          "Country Code",
          "Notes",
          "Active",
          "Language",
          "Language Code",
        ];

        const fieldLabels = {
          countryName: "Country Name",
          countryCode: "Country Code",
          notes: "Notes",
          active: "Active",
          language: "Language",
          languageCode: "Language Code",
        };

        const readableData = allowedKeys.map((key) => fieldLabels[key] || key);
        this.getColumns = readableData;

        this.selectedColumns = [...this.getColumns];

        this.selectedcolumnobj = this.selectedColumns.reduce((obj, key) => {
          obj[key] = true;
          return obj;
        }, {});
      }
    },

    async listCohort() {
      try {
        this.showTableLoading = true;
        const currentstudy = store.getters.getStudyIs;
        this.idToken = store.getters.getIdToken;

        const response = await axios.get(`${this.baseurl}/management/cohort/search?StudyId=${currentstudy}&pageindex=1&pagesize=10&SortOrder=${this.SortOrderInt}&SortProperty=${this.SortProperty}`, {
          headers: {
            Authorization: "Bearer " + this.idToken,
            "Content-Type": "application/json"
          }
        });
        this.CohortList = response.data.data || [];
        console.log("Cohort List:", this.CohortList);
        this.totalCount = this.CohortList.length;
        this.totalPage = Math.ceil(this.totalCount / this.pagesize);
      } catch (error) {
        console.error("Error fetching arms:", error);
        this.CohortList = [];
      } finally {
        this.showTableLoading = false;
      }
    },


    loadPage(page) {
      this.currentPage = page;
      this.listCohort();
    },

    async search() {
      this.pageindex = 1;
      this.currentPage = 1;
      this.listCohort();
    },

    formatDateDDMMYYYY(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getUTCDate()).padStart(2, "0");
      const month = String(d.getUTCMonth() + 1).padStart(2, "0");
      const year = d.getUTCFullYear();
      return `${day}-${month}-${year}`;
    },



    closeCohortModal() {
      this.showCreateCohortModal = false;
      this.editingCohortId = null;
    },

    CreateCohort() {
      this.editingCohortId = null;
      this.showCreateCohortModal = true;
    },

    EditCohort(id) {
      if (!id) {
        alert("Cohort id not found.");
        return;
      }

      this.editingCohortId = id;
      this.showCreateCohortModal = true;
    },

    async DeleteCohort(id) {
      const DELETE_COHORT_URL = `${this.baseurl}/management/cohort/delete`;
      if (!id) {
        alert("Cohort id not found.");
        return;
      }

      if (!confirm("Are you sure you want to delete this Cohort?")) {
        return;
      }

      try {
        this.idToken = store.getters.getIdToken;
        await axios.delete(`${DELETE_COHORT_URL}?Id=${id}`, {
          headers: {
            Authorization: "Bearer " + this.idToken,
            "Content-Type": "application/json"
          }
        });

        alert("Cohort deleted successfully.");
        await this.listCohort();
      } catch (error) {
        console.error("Error deleting cohort:", error);
        alert(
          error.response?.data?.detail ||
          error.response?.data?.message ||
          "Failed to delete cohort."
        );
      }
    },

    async refreshCohortList() {
      await this.listCohort();
    }
  }
};
